import d from "../hooks/useSlackConnectionStatus.mjs";
import * as o from "react";
import "swr/infinite";
import { useKnockClient as S } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import { slackProviderKey as C } from "../../core/utils.mjs";
import "../../i18n/context/KnockI18nProvider.mjs";
const a = o.createContext(null), I = (t) => {
  const {
    knockSlackChannelId: e,
    children: i
  } = t, n = "tenantId" in t ? t.tenantId : t.tenant, l = S(), {
    connectionStatus: r,
    setConnectionStatus: s,
    errorLabel: c,
    setErrorLabel: k,
    actionLabel: m,
    setActionLabel: u
  } = d(l, e, n);
  return /* @__PURE__ */ o.createElement(a.Provider, { key: C({
    knockSlackChannelId: e,
    tenantId: n,
    connectionStatus: r,
    errorLabel: c
  }), value: {
    connectionStatus: r,
    setConnectionStatus: s,
    errorLabel: c,
    setErrorLabel: k,
    actionLabel: m,
    setActionLabel: u,
    knockSlackChannelId: e,
    // Assign the same value to both tenant and tenantId for backwards compatibility
    tenant: n,
    tenantId: n
  } }, i);
}, L = () => {
  const t = o.useContext(a);
  if (t === void 0)
    throw new Error("useKnockSlackClient must be used within a KnockSlackProvider");
  return t;
};
export {
  I as KnockSlackProvider,
  L as useKnockSlackClient
};
//# sourceMappingURL=KnockSlackProvider.mjs.map
